import { apiUrls, attFormats, reportHeights } from 'consts'
import { useEffect } from 'react'
import loadRecord from './../utils/loadRecord'
import getAll from 'utils/getAll'

interface useInitProps {
  getValues: Function
  setValue: Function
  id: string | undefined
  reset: Function
  setDataLoaded: Function
  setShowOverlay: Function
  currentCustomer: {} | null
  setVslzReports: Function
  setAisReports: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    let vslzReports : Array<any> = []
    const vslzReportsRequest = getAll(apiUrls.actionGetVslzReports).then((data) => {
      props.setVslzReports(data)
      vslzReports = data
    })
    
    let aisReports : Array<any> = []
    const aisReportsRequest = getAll(apiUrls.actionGetAisReports).then((data) => {
      props.setAisReports(data)
      aisReports = data
    })

    if (props.id !== undefined) {
      let reportData : any = null
      const reportRequest = loadRecord(apiUrls.reports, props.id).then((data) => {
        reportData = data
        const attFormatsSelected: Array<{ id: string; name: string }> = []
        const reportHeightSelected: { id: string; name: string } | null = reportHeights.find((h) => h.id === data.height) ?? null

        data.formats.forEach((fmtSelected) => {
          const attFmtObj: { id: string; name: string } | undefined = attFormats.find(
            (f) => f.id === fmtSelected,
          )
          if (attFmtObj !== undefined) {
            attFormatsSelected.push(attFmtObj)
          }
        })
        

        const dataNormalized = {
          ...data,
          formats: attFormatsSelected,
          height: reportHeightSelected
        }

        props.reset(dataNormalized)

      })

      Promise.all([
        vslzReportsRequest,
        aisReportsRequest,
        reportRequest
      ]).then(() => {
        const vslzReportSelected : any = vslzReports.find(i => i.id === reportData.vslz_id?.toString())
        props.setValue('vslz_report', vslzReportSelected)
        const aisReportSelected : any = aisReports.find(i => i.id === reportData.ais_id)
        props.setValue('ais_report', aisReportSelected)
        props.setDataLoaded(true)
        props.setShowOverlay(false)
      })

    } else {
      
      props.reset({
        formats: [],
        height: reportHeights[0]
      })

      Promise.all([
        vslzReportsRequest,
      ]).then(() => {
        props.setDataLoaded(true)
        props.setShowOverlay(false)
      })
    }
  }, [props.currentCustomer])
}

export default useInit
